var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"id":"recipient","dense":"","name":"recipient","label":"Recipient","outlined":""},model:{value:(_vm.recipient),callback:function ($$v) {_vm.recipient=$$v},expression:"recipient"}})
}
var staticRenderFns = []

export { render, staticRenderFns }